import React from "react";

export const BancontactQRSection = ({ className = "" }) => (
  <div className={`p-4 rounded-xl bg-[#003b7c] text-white text-center ${className}`} data-testid="bancontact-qr-section">
    <p className="text-sm font-semibold mb-3 tracking-wide">Proposez au client de payer via Bancontact</p>
    <div className="inline-block bg-white rounded-xl p-1 shadow-lg">
      <img
        src="https://customer-assets.emergentagent.com/job_05768802-3fed-4692-b7db-a8a05a19713e/artifacts/wwkuasnl_Capture%20d%E2%80%99e%CC%81cran%202026-04-10%20a%CC%80%2008.41.06.png"
        alt="QR Code Bancontact Pay / Wero"
        className="w-48 h-48 sm:w-56 sm:h-56 md:w-64 md:h-64 object-contain rounded-lg"
        data-testid="bancontact-qr-image"
      />
    </div>
    <p className="text-xs mt-3 text-white/70">Scannez avec l'app Bancontact Pay ou Wero</p>
  </div>
);
